<button (click)="editData(params)" title="Edit" *ngIf="isEditVisible" style="padding-right: 10px">
    <img src="/assets/edit.svg" height="25" width="20" alt="Edit Icon" style="margin-bottom: 5px;"/>
</button>
